export default "__VITE_ASSET__CiRiT5XW__"